<nb-layout center>
  <nb-layout-column>
    <nb-card-body>
      <nb-auth-block aria-labelledby="title">
        <div class="col-lg-10 offset-lg-3 col-sm-12 offset-sm-0">

          <div class="logo"><img src="/assets/images/new_logo.svg" alt=""></div>
          <p i18n="@@AdministrationSystem" class="stitle">Решения для автоматизации оптовых<br>бизнес-процессов и продаж</p>

          <div class="alert alert-danger" *ngIf="(state.get('serverError') | async) === true">
            Возникла ошибка. Попробуйте позже
          </div>
          <div class="alert alert-danger" *ngIf="(state.get('lockedError') | async) === true">
            <span i18n="@@ServerError">Временная блокировка. Вы ввели неверные данные 5 раз. Попробуйте позже</span>
          </div>
          <div class="alert alert-danger" *ngIf="(state.get('status') | async) === 403">
            <span i18n="@@LoginPassIncorrect">Неверно указан логин и/или пароль</span>
          </div>

          <form aria-labelledby="title" [formGroup]="loginForm" (ngSubmit)="onSubmit()" style="text-align: center">
            <div class="form-control-group">
              <input nbInput
                     fullWidth
                     formControlName="login"
                     type="text"
                     name="login"
                     id="input-email"
                     i18n-placeholder="@@UserName"
                     placeholder="имя пользователя"
              >
            </div>

            <div class="form-control-group">
              <input i18n-placeholder="@@Password" nbInput
                     fullWidth
                     formControlName="password"
                     name="password"
                     type="password"
                     id="input-password"
                     placeholder="пароль"
              >
            </div>
            <button nbButton
                    [disabled]="!loginForm.valid"
                    status="primary"
                    i18n="@@SignIn"
                    type="submit"
                    style="width: 150px"
            >
              Войти
            </button>
          </form>
        </div>
      </nb-auth-block>
    </nb-card-body>
  </nb-layout-column>
</nb-layout>
